
module.exports = {
    Base_URL:process.env.REACT_APP_API_URL, 
    Rakeyid:process.env.REACT_APP_RAKEYID
}